import React from "react";

export default function IconUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
      >
        <path
          d="M39.6893 36.4373C37.0716 31.9118 33.0377 28.6668 28.3301 27.1285C30.6587 25.7423 32.4679 23.63 33.4798 21.116C34.4917 18.602 34.6505 15.8254 33.9316 13.2124C33.2127 10.5995 31.656 8.29481 29.5005 6.65226C27.345 5.0097 24.7099 4.12012 21.9999 4.12012C19.2899 4.12012 16.6548 5.0097 14.4993 6.65226C12.3438 8.29481 10.7871 10.5995 10.0683 13.2124C9.34938 15.8254 9.50809 18.602 10.52 21.116C11.5319 23.63 13.3411 25.7423 15.6698 27.1285C10.9621 28.6651 6.9282 31.9101 4.31054 36.4373C4.21455 36.5938 4.15087 36.768 4.12328 36.9495C4.09569 37.131 4.10473 37.3163 4.14988 37.4942C4.19503 37.6722 4.27537 37.8393 4.38615 37.9858C4.49694 38.1322 4.63593 38.255 4.79493 38.3468C4.95392 38.4386 5.1297 38.4977 5.3119 38.5205C5.49409 38.5433 5.67901 38.5294 5.85573 38.4796C6.03246 38.4297 6.19742 38.345 6.34088 38.2304C6.48434 38.1158 6.60339 37.9737 6.69101 37.8123C9.92913 32.216 15.6526 28.8748 21.9999 28.8748C28.3473 28.8748 34.0707 32.216 37.3088 37.8123C37.3964 37.9737 37.5155 38.1158 37.659 38.2304C37.8024 38.345 37.9674 38.4297 38.1441 38.4796C38.3208 38.5294 38.5057 38.5433 38.6879 38.5205C38.8701 38.4977 39.0459 38.4386 39.2049 38.3468C39.3639 38.255 39.5029 38.1322 39.6137 37.9858C39.7245 37.8393 39.8048 37.6722 39.8499 37.4942C39.8951 37.3163 39.9041 37.131 39.8765 36.9495C39.849 36.768 39.7853 36.5938 39.6893 36.4373ZM12.3749 16.4998C12.3749 14.5961 12.9394 12.7353 13.997 11.1524C15.0546 9.56961 16.5578 8.33595 18.3166 7.60745C20.0753 6.87896 22.0106 6.68835 23.8777 7.05973C25.7447 7.43112 27.4597 8.34781 28.8058 9.69389C30.1519 11.04 31.0686 12.755 31.44 14.622C31.8114 16.4891 31.6208 18.4244 30.8923 20.1831C30.1638 21.9419 28.9301 23.4451 27.3473 24.5027C25.7645 25.5603 23.9036 26.1248 21.9999 26.1248C19.448 26.1221 17.0015 25.1071 15.197 23.3027C13.3926 21.4982 12.3776 19.0517 12.3749 16.4998Z"
          fill="#FDFEFF"
        />
        <path
          d="M22 1.5C28.9629 1.5 34.5 6.48072 34.5 12.5C34.5 18.5193 28.9629 23.5 22 23.5C15.0371 23.5 9.5 18.5193 9.5 12.5C9.5 6.48072 15.0371 1.5 22 1.5Z"
          stroke="url(#paint0_linear_1395_16008)"
        />
        <ellipse cx="35" cy="15.5" rx="2" ry="6.5" fill="white" />
        <ellipse cx="9" cy="15.5" rx="2" ry="6.5" fill="#FDFEFF" />
        <circle cx="24.5" cy="19.5" r="1.5" fill="#FDFEFF" />
        <line x1="25" y1="19.5" x2="32" y2="19.5" stroke="white" />
        <defs>
          <linearGradient
            id="paint0_linear_1395_16008"
            x1="22"
            y1="1"
            x2="22"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.44" stop-color="white" />
            <stop offset="1" stop-color="#CDCDCD" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </svg>
  );
}
